import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { UserAuthProvider } from "@/context/UserAuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programs from "@/pages/Programs";
import ProgramDetail from "@/pages/ProgramDetail";
import ESAFC from "@/pages/ESAFC";
import GetInvolved from "@/pages/GetInvolved";
import Contact from "@/pages/Contact";
import DonationSuccess from "@/pages/DonationSuccess";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import MyPrograms from "@/pages/MyPrograms";
import SharedPrograms from "@/pages/SharedPrograms";
import Unsubscribe from "@/pages/Unsubscribe";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import FAQChatbot from "@/components/FAQChatbot";
import useLenis from "@/hooks/useLenis";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  useLenis();

  // CRITICAL: synchronous check for Emergent OAuth callback — must run before any ProtectedRoute.
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const hideChat = location.pathname.startsWith("/admin");

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/:slug" element={<ProgramDetail />} />
          <Route path="/esafc" element={<ESAFC />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/my-programs" element={<MyPrograms />} />
          <Route path="/shared/:shareId" element={<SharedPrograms />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/donate/success" element={<DonationSuccess />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Route>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      {!hideChat && <FAQChatbot />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <UserAuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </UserAuthProvider>
    </AuthProvider>
  );
}
